import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import {
  createSportsbookState,
  SiteConfigManager,
  SportsbookProvider,
  useSettings,
} from '@atlas/core';
import { SportsbookRouter } from '@atlas/routing';

import { SIMPLIFIED_SPORTSBOOK_PATH_PATTERN } from 'common/constants';
// FIXME: Needs refactoring
import SportsbookMaintenanceContainer from 'components/MaintenanceContainer/SportsbookMaintenanceContainer';
import SimplifiedSportsbookView from 'components/Pages/Prematch/SimplifiedSportsbookView';
import { isValidTimeFilter, timeQueryName } from 'components/SimpleFilters/DropdownTime';

import PrematchSportsbookView from './PrematchSportsbookView';

const PrematchSportsbookProvider = props => {
  const { children, sportsbookProps } = props;

  const { categoryName, sportName, tournamentName } = useParams();

  const sportbookState = createSportsbookState({
    id: 'sport',
    selectedCategoryUrlName: categoryName,
    selectedSportUrlName: sportName,
    selectedTournamentUrlName: tournamentName,
    sportServices: ['LIVE', 'PREMATCH'],
    ...sportsbookProps,
  });

  return <SportsbookProvider value={sportbookState}>{children}</SportsbookProvider>;
};

const PrematchSportsbook = () => {
  const { lang } = useSettings();
  const { search } = useLocation();
  const {
    location: { state = {} },
    push: historyPush,
  } = useHistory();

  React.useEffect(() => {
    if (state?.redirectPath) historyPush(state.redirectPath);
  }, [state?.redirectPath, historyPush]);

  const isSimplifiedView = React.useMemo(
    () => SiteConfigManager.getConfig('config.config.sportsbook.mobileGridViewType'),
    [],
  );

  const props = {};
  const sportsbookProps = {};
  if (isSimplifiedView === 'simplified') {
    const timeQuery = new URLSearchParams(search).get(timeQueryName);

    if (isValidTimeFilter(timeQuery)) {
      const filter = {
        dateFilterType: timeQuery ? `${timeQuery}h` : null,
        timeHours: timeQuery ? Number(timeQuery) : null,
      };

      sportsbookProps.categoryFilter = filter;
      sportsbookProps.tournamentFilter = filter;
    }

    props.path = SIMPLIFIED_SPORTSBOOK_PATH_PATTERN;
  }

  return (
    <SportsbookMaintenanceContainer>
      <SportsbookRouter {...props}>
        <PrematchSportsbookProvider key={lang} sportsbookProps={sportsbookProps}>
          {isSimplifiedView === 'simplified' ? (
            <SimplifiedSportsbookView path="/sportsbook" />
          ) : (
            <PrematchSportsbookView />
          )}
        </PrematchSportsbookProvider>
      </SportsbookRouter>
    </SportsbookMaintenanceContainer>
  );
};

export default PrematchSportsbook;
